import { getToken } from '@helpscout/hsds-tokens/getToken'
import styled from 'styled-components'

export const StatusDotUI = styled('div')`
  --hsds-status-dot-size: 8px;
  --hsds-status-dot-color: ${getToken('statusDot.color.light.slate')};
  --hsds-status-border-radius: 50%;
  --hsds-status-border-width: 4px;
  --hsds-status-background: ${getToken('statusDot.color.light.background')};

  box-sizing: border-box;
  background-color: var(--hsds-status-background);
  border-radius: var(--hsds-status-border-radius);
  border: var(--hsds-status-border-width) solid var(--hsds-status-dot-color);
  height: var(--hsds-status-dot-size);
  width: var(--hsds-status-dot-size);
  color: transparent;
  box-shadow: var(--hsds-status-dot-box-shadow);

  &.over-dark-bg {
    --hsds-status-dot-color: ${getToken('statusDot.color.dark.slate')};
    --hsds-status-background: ${getToken('statusDot.color.dark.background')};
  }

  &.is-variant-square,
  &.is-variant-square-outline {
    --hsds-status-border-radius: 1px;
  }

  &.is-variant-circle-outline,
  &.is-variant-square-outline {
    --hsds-status-border-width: 2px;
  }

  &.is-dot-color-green {
    --hsds-status-dot-color: ${getToken('statusDot.color.light.green')};

    &.over-dark-bg {
      --hsds-status-dot-color: ${getToken('statusDot.color.dark.green')};
    }
  }

  &.is-dot-color-red {
    --hsds-status-dot-color: ${getToken('statusDot.color.light.red')};

    &.over-dark-bg {
      --hsds-status-dot-color: ${getToken('statusDot.color.dark.red')};
    }
  }

  &.is-dot-color-yellow {
    --hsds-status-dot-color: ${getToken('statusDot.color.light.yellow')};

    &.over-dark-bg {
      --hsds-status-dot-color: ${getToken('statusDot.color.dark.yellow')};
    }
  }

  &.is-dot-color-purple {
    --hsds-status-dot-color: ${getToken('statusDot.color.light.purple')};

    &.over-dark-bg {
      --hsds-status-dot-color: ${getToken('statusDot.color.dark.purple')};
    }
  }

  &.is-dot-color-charcoal,
  &.is-dot-color-grey,
  &.is-dot-color-gray {
    --hsds-status-dot-color: ${getToken('statusDot.color.light.charcoal')};

    &.over-dark-bg {
      --hsds-status-dot-color: ${getToken('statusDot.color.dark.charcoal')};
    }
  }

  &.is-inline {
    display: inline-block;
  }

  &.is-icon {
    background-color: white;
    border-width: 0;
    height: 18px;
    width: 18px;
  }
`

export const CenteredContentUI = styled('div')`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export function mapStatusToColor(status: string) {
  if (
    status === 'online' ||
    status === 'new' ||
    status === 'available' ||
    status === 'active'
  )
    return 'green'

  if (status === 'offline' || status === 'unavailable') return 'red'
  if (status === 'assign' || status === 'busy') return 'yellow'
  if (status === 'away') return 'charcoal'
  if (status === 'custom') return 'purple'

  return 'slate'
}

export function mapStatusToVariant(status: string, icon?: boolean) {
  if (icon) return 'circle'

  if (
    status === 'online' ||
    status === 'new' ||
    status === 'available' ||
    status === 'active'
  )
    return 'circle'

  if (status === 'offline' || status === 'unavailable') return 'circle-outline'

  if (status === 'assign' || status === 'busy') return 'circle-outline'

  if (status === 'away') return 'circle-outline'

  if (status === 'custom') return 'square'

  return 'circle'
}
